import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "Marketplace",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getMarketplace, getMarketplaceError, getMarketplaceSuccess } =
  slice.actions;

reducerRegistry.register("marketplace", reducer);
